"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _MobileHeader = _interopRequireDefault(require("../MobileHeader"));

var _Desktop = _interopRequireDefault(require("./Desktop"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _Mobile = _interopRequireDefault(require("./Mobile"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  return {
    root: {
      zIndex: 10,
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%'
    }
  };
};

var ResponsiveHeader = function ResponsiveHeader(props) {
  var LogoProps = props.LogoProps,
      className = props.className,
      style = props.style,
      children = props.children;
  var classes = useStyles();
  return (0, _core.jsx)(_MobileHeader["default"], {
    css: classes.root,
    className: className,
    style: style
  }, (0, _core.jsx)(_Logo["default"], LogoProps), (0, _core.jsx)(_Mobile["default"], {
    LogoProps: LogoProps
  }, children), (0, _core.jsx)(_Desktop["default"], null, children));
};

__signature__(ResponsiveHeader, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = ResponsiveHeader;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/index.tsx");
  reactHotLoader.register(ResponsiveHeader, "ResponsiveHeader", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();